export enum FileExtensionsEnum {
    Pdf = 'pdf',
    Png = 'png',
    Jpg = 'jpg',
    Jpeg = 'jpeg',
    Xls = 'xls',
    Xlsx = 'xlsx',
    Csv = 'csv',
    Zip='zip'
}
